import { Controller } from "@hotwired/stimulus"

// Shared chat composer behavior for both beam worlds (viewer console + operator
// reply-as-robot): textarea autosize, Cmd/Ctrl+Enter submit, canned-text insert,
// attachment count badge, and clearing after a successful Turbo submission.
export default class extends Controller {
  static targets = ["form", "input", "files", "fileBadge", "canned"]

  connect() {
    this.autosize()
    this.onSubmitEnd = (event) => {
      if (event.detail.success) this.reset()
    }
    this.element.addEventListener("turbo:submit-end", this.onSubmitEnd)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.onSubmitEnd)
  }

  autosize() {
    if (!this.hasInputTarget) return
    const input = this.inputTarget
    input.style.height = "auto"
    input.style.height = `${Math.min(input.scrollHeight, 160)}px`
  }

  submitOnEnter(event) {
    if (event.key !== "Enter" || !(event.metaKey || event.ctrlKey)) return
    event.preventDefault()
    this.element.closest("form")?.requestSubmit() || this.formTarget?.requestSubmit()
  }

  insertCanned(event) {
    if (!this.hasInputTarget) return
    const text = event.currentTarget.dataset.text || ""
    const input = this.inputTarget
    input.value = input.value ? `${input.value.replace(/\s+$/, "")} ${text}` : text
    input.focus()
    input.setSelectionRange(input.value.length, input.value.length)
    this.autosize()
    if (this.hasCannedTarget) this.cannedTarget.removeAttribute("open")
  }

  fileCount() {
    if (!this.hasFileBadgeTarget || !this.hasFilesTarget) return
    const count = this.filesTarget.files.length
    this.fileBadgeTarget.textContent = count > 0 ? String(count) : ""
    this.fileBadgeTarget.classList.toggle("hidden", count === 0)
  }

  reset() {
    if (this.hasInputTarget) this.inputTarget.value = ""
    if (this.hasFilesTarget) this.filesTarget.value = ""
    this.fileCount()
    this.autosize()
  }
}
